<template>
  <div ref="featureCard" :class="`feature-card ${classModifier}`">
    <div v-if="item.icon" class="feature-card__icon">
      <img
        v-if="item.icon && isSvgFile(item.icon)"
        :src="item.icon"
        :alt="item.title"
      />
      <component
        :is="'a_imageSource' | dashify"
        v-if="item.icon && !isSvgFile(item.icon)"
        :blok="item"
        :image-url="item.icon"
        :alt="item.title"
      />
    </div>
    <hr />
    <h4 v-if="item.title && !item.tween_title" class="feature-card__title">
      {{ item.title }}
    </h4>
    <h4 v-if="item.title && item.tween_title" class="feature-card__title">
      {{ item.tween_append_symbol }}
      {{ animatedNumber }}
      {{ item.tween_prepend_symbol }}
    </h4>
    <p v-if="item.description" class="feature-card__description">
      {{ item.description }}
    </p>
  </div>
</template>

<script>
import * as GREENSOCK from 'gsap'

export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    classModifier: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      scrollFunction: null,
      speed: 0.8,
      number: 0,
      tweenedNumber: 0,
    }
  },
  computed: {
    animatedNumber() {
      return this.number % 1 === 0
        ? this.tweenedNumber.toFixed(0)
        : this.tweenedNumber.toFixed(1)
    },
  },
  watch: {
    visible(visible) {
      if (visible && this.item.tween_title) {
        this.number = parseFloat(this.item.title.replace(/,/g, ''))
      }
    },
    number(newValue) {
      this.TweenLite.to(this.$data, this.speed, {
        tweenedNumber: newValue,
      })
    },
  },
  mounted() {
    if (this.item.tween_title) {
      this.TweenLite = GREENSOCK.TweenLite
    }
  },
  methods: {
    isSvgFile(file) {
      return file.split('.').pop() === 'svg'
    },
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/settings';

.theme-dark .feature-card hr {
  background-color: $white;
}

.feature-card {
  margin-bottom: 42px;

  &__icon {
    display: flex;
    height: 60px;
    margin: 0 0 15px;

    img {
      max-height: 100%;
      max-width: 100%;
    }
  }

  hr {
    width: 27px;
    height: 2px;
    display: inline-block;
    background-color: $mine-shaft;
    border: 0;
  }

  &__title {
    @include font-family($font-family-headings-bold, $headings-font-weight);

    line-height: 26px;
    margin-top: 0;
  }

  &__description {
    margin: 28px 0 0;
  }

  &--article {
    margin: 0;

    .feature-card__title {
      text-overflow: ellipsis;
      overflow: hidden;
      @include font-size(60, rem-v(54));

      white-space: nowrap;
    }

    .feature-card__description {
      margin: 18px 0 0;
    }
  }
}

@include media-breakpoint-up(md) {
  .feature-card {
    margin-bottom: 54px;

    &--article {
      margin: 0;
    }
  }
}
</style>
